import React from "react";
import styles from "./LoadingScreen.module.css";
import diffusionIconLight from "../../assets/noah_loading_light.svg";
import diffusionIconDark from "../../assets/noah_loading_dark.svg";
import { useThemedIcon } from "../../hooks/useThemedIcon";

const LoadingScreen: React.FC = () => {
  const { getIcon } = useThemedIcon();
  const diffusionIcon = getIcon(diffusionIconLight, diffusionIconDark);

  return (
    <div className={styles.loadingScreen}>
      <img src={diffusionIcon} alt="Loading" className={styles.loadingIcon} />
    </div>
  );
};

export default LoadingScreen;
